module.exports = {
  annotate: require('./annotation').annotate,
  Module: require('./module'),
  Injector: require('./injector')
};



// WEBPACK FOOTER //
// ./~/didi/lib/index.js